import { createAction } from "typesafe-actions";

import type { PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";

import type {
    CrmEnrichmentJobDTO,
    CrmEnrichmentJobFilterType,
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    EnrichmentJobMappingDTO,
    LeadScoreRefreshDataInterval,
} from "../types/types";

export const setRemoveModalOpen = createAction("@@si/crm-enrichment/remove-modal-open-set")<boolean>();

export const setRenameModalOpen = createAction("@@si/crm-enrichment/rename-modal-open-set")<boolean>();

export const resetNameModalState = createAction("@@si/crm-enrichment/reset-name-modal-state")();

export const setJobName = createAction("@@si/crm-enrichment/job-name-set")<string>();

export const setSelectedJobType = createAction("@@si/crm-enrichment/selected-job-type-set")<
    CrmEnrichmentJobType | ""
>();

export const setSelectedJobObject = createAction(
    "@@si/crm-enrichment/selected-job-object-set",
)<CrmEnrichmentJobObject>();

export const setSelectedJobRefreshPeriod = createAction(
    "@@si/crm-enrichment/selected-job-refresh-period-set",
)<CrmEnrichmentJobRefreshPeriod>();

export const setSelectedCountryId = createAction("@@si/crm-enrichment/selected-country-id-set")<number | null>();

export const setSelectedEnrichmentSource = createAction(
    "@@si/crm-enrichment/selected-enrichment-source-set",
)<CrmEnrichmentSource>();

export const setSelectedLeadScoreRefreshDataInterval = createAction(
    "@@si/crm-enrichment/selected-lead-score-refresh-data-interval-set",
)<LeadScoreRefreshDataInterval | "">();

export const setJobState = createAction("@@si/crm-enrichment/set-job-state")<Omit<CrmEnrichmentJobDTO, "filters">>();

export const resetJobState = createAction("@@si/crm-enrichment/reset-job-state")();

export const setIsApplyFiltersSelected = createAction("@@si/crm-enrichment/is-apply-filters-selected-set")<
    boolean | null
>();

export const addFilter = createAction("@@si/crm-enrichment/filter-add")();

export const deleteFilter = createAction("@@si/crm-enrichment/filter-delete")<number>();

export const setFilterField = createAction("@@si/crm-enrichment/filter-field-set")<{
    id: number;
    field: string;
    dataType: PredefinedValueType;
    pickListItems: readonly string[];
}>();

export const setFilterValue = createAction("@@si/crm-enrichment/filter-value-set")<{
    id: number;
    key: keyof CrmEnrichmentJobFilterType;
    value: CrmEnrichmentJobFilterType[keyof CrmEnrichmentJobFilterType];
}>();

export const resetWizardFilters = createAction("@@si/crm-enrichment/wizard-filters-reset")();

export const initializeFiltersFromJob = createAction("@@si/crm-enrichment/filters-from-job-initialize")<{
    filters: readonly CrmEnrichmentJobFilterType[];
    isApplyFiltersSelected: boolean;
}>();

export const setMappings = createAction(
    "@@si/crm-enrichment/mappings-set",
)<readonly EnrichmentJobMappingDTO[]>();

export const addMapping = createAction("@@si/crm-enrichment/mapping-add")<EnrichmentJobMappingDTO>();

export const removeMapping = createAction("@@si/crm-enrichment/mapping-remove")<number>();

export const updateMapping = createAction("@@si/crm-enrichment/mapping-update")<{
    index: number;
    changes: Partial<EnrichmentJobMappingDTO>;
}>();
